/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { ChatContext } from "../../context/ChatContext";
import { getWebRole, getCompanyId, getChatUser } from "../../util/localStorage";
import { chatIcon } from "../../assets/images";
import "./navbarChatNotifications.scss";

const NavbarChatNotifications = ({ handleLinkClick }) => {
  const history = useHistory();
  const chatContext = useContext(ChatContext);
  const [projectsWithChats, setProjectsWithChats] = useState([]);
  const role = getWebRole();
  const companyId = getCompanyId();
  const twilioEmail = getChatUser();

  const { twilioClient, projects, globalUnreadCount, refreshUnreadCounts, markConversationAsRead, updateGlobalUnreadCount } = chatContext || {};

  useEffect(() => {
    if (chatContext && projects && projects.length > 0 && globalUnreadCount > 0 && twilioClient) {
      findProjectsWithUnreadMessages();
    } else {
      setProjectsWithChats([]);
    }
  }, [projects, globalUnreadCount, twilioClient, chatContext]);


  // Return early if ChatContext is not available (e.g., on login page)
  if (!chatContext) {
    return null;
  }

  const findProjectsWithUnreadMessages = async (forceRefresh = false) => {
    if (!chatContext || !twilioClient || !projects) {
      setProjectsWithChats([]);
      return;
    }

    try {
      const projectsWithUnread = [];
      
      // Get all subscribed conversations once
      const conversations = await twilioClient.getSubscribedConversations();
      const conversationMap = new Map();
      
      // Create a map of conversation unique names to their unread counts
      // Only process conversations that have unread messages
      await Promise.all(conversations.items.map(async (conv) => {
        try {
          const lastReadIndex = conv.lastReadMessageIndex;
          const lastMsgIndex = conv.lastMessage?.index;

          if (lastMsgIndex === undefined || lastMsgIndex === null) return;
          if (lastReadIndex !== null && lastReadIndex >= lastMsgIndex) return;

          const startIndex = lastReadIndex !== null ? lastReadIndex + 1 : 0;
          const pageSize = Math.min(lastMsgIndex - startIndex + 1, 1000);

          if (pageSize <= 0) return;

          const msgPage = await conv.getMessages(pageSize, startIndex, "forward");
          const unreadFromOthers = msgPage.items.filter(
            (msg) => msg.author !== twilioEmail
          ).length;

          if (unreadFromOthers > 0) {
            conversationMap.set(conv.uniqueName, unreadFromOthers);
          }
        } catch (err) {
          // Ignore errors for individual conversations
        }
      }));

      // Only add projects that have conversations with unread messages
      for (const project of projects) {
        if (!project.groupChats || !Array.isArray(project.groupChats)) {
          continue;
        }

        let totalUnreadCount = 0;
        for (const groupChat of project.groupChats) {
          if (groupChat.groupChatId && conversationMap.has(groupChat.groupChatId)) {
            totalUnreadCount += conversationMap.get(groupChat.groupChatId);
          }
        }

        if (totalUnreadCount > 0) {
          projectsWithUnread.push({
            ...project,
            unreadCount: totalUnreadCount
          });
        }
      }

      setProjectsWithChats(projectsWithUnread.slice(0, 8)); // Limit to 8 projects
      
      const dropdownTotalUnread = projectsWithUnread.reduce((sum, project) => sum + project.unreadCount, 0);
      
      // If dropdown has a more accurate count, update the global count immediately
      // if (dropdownTotalUnread !== globalUnreadCount && updateGlobalUnreadCount && dropdownTotalUnread > 0) {
      //   console.log('Dropdown detected different count - updating global from', globalUnreadCount, 'to', dropdownTotalUnread);
      //   updateGlobalUnreadCount(dropdownTotalUnread);
      // }
    } catch (error) {
      console.error('Error finding projects with unread messages:', error);
      setProjectsWithChats([]);
    }
  };

  const handleProjectClick = (project, groupChat = null) => {
    if (handleLinkClick) {
      handleLinkClick();
    }

    if (companyId > 0 && role === "3") {
      // Client
      if (groupChat) {
        history.push(`/client-job/job-entity/7/${project.projectId}?groupId=${groupChat.groupId}`);
      } else {
        history.push(`/client-job/job-entity/7/${project.projectId}`);
      }
    } else {
      // Talent
      if (groupChat) {
        history.push(`/jobcenter/inprogress/job-details/${project.projectId}/5?groupId=${groupChat.groupId}`);
      } else {
        history.push(`/jobcenter/inprogress/job-details/${project.projectId}/5`);
      }
    }

    let conversationToMarkAsRead = null;
    
    if (groupChat) {
      conversationToMarkAsRead = groupChat.groupChatId;
    } else {
      const defaultGroupChat = project.groupChats?.find(gc => gc.isDefaultGroup === true);
      if (defaultGroupChat) {
        conversationToMarkAsRead = defaultGroupChat.groupChatId;
      } else {
        const firstGroupChat = project.groupChats?.find(gc => gc.groupChatId);
        if (firstGroupChat) {
          conversationToMarkAsRead = firstGroupChat.groupChatId;
        }
      }
    }

    if (conversationToMarkAsRead && markConversationAsRead) {
      setTimeout(() => {
        markConversationAsRead(conversationToMarkAsRead);
      }, 1000);
    }
  };

  const handleViewAllChats = () => {
    if (handleLinkClick) {
      handleLinkClick();
    }
    history.push('/chats');
  };

  return (
    <div className="navbarChatNotifications">
      <div className="navbarChatNotifications-header">
        <div className="navbarChatNotifications-title font18Black">
          Chat Notifications
          {(globalUnreadCount || 0) > 0 && (
            <span className="navbarChatNotifications-total-badge">
              {globalUnreadCount}
            </span>
          )}
        </div>
        <button 
          className="navbarChatNotifications-view-all"
          onClick={handleViewAllChats}
        >
          View All
        </button>
      </div>
      
      <div className="navbarChatNotifications-divider" />
      
      <div className="navbarChatNotifications-body">
        {(globalUnreadCount || 0) === 0 ? (
          <div className="navbarChatNotifications-empty">
            <div className="navbarChatNotifications-empty-icon">
              <img src={chatIcon} alt="No messages" />
            </div>
            <p className="navbarChatNotifications-empty-text">No unread messages</p>
          </div>
        ) : projectsWithChats.length === 0 ? (
          <div className="navbarChatNotifications-empty">
            <div className="navbarChatNotifications-empty-icon">
              <img src={chatIcon} alt="No projects" />
            </div>
            <p className="navbarChatNotifications-empty-text">No projects with chats available</p>
          </div>
        ) : (
          <>
            {/* <div className="navbarChatNotifications-list-header">
              Projects with unread messages:
            </div> */}
            {projectsWithChats.map((project, index) => (
              <React.Fragment key={project.projectId || index}>
                <div className="navbarChatNotifications-project">
                  <div className="navbarChatNotifications-project-content">
                    <div className="navbarChatNotifications-project-info">
                      <div className="navbarChatNotifications-project-name" title={project.projectName}>
                        {project.projectName || 'Unnamed Project'}
                      </div>
                    </div>
                    <button 
                      className="navbarChatNotifications-project-button"
                      onClick={() => handleProjectClick(project)}
                      title="Go to project chat"
                    >
                      View Chat
                    </button>
                  </div>
                  <div className="navbarChatNotifications-project-count">
                    {project.unreadCount} unread message{project.unreadCount !== 1 ? 's' : ''}
                  </div>
                </div>
                <div className="navbarChatNotifications-project-divider" />
              </React.Fragment>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default NavbarChatNotifications;
